import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Scanner from "@/pages/Scanner";
import LiveTerminal from "@/pages/LiveTerminal";
import Vulnerabilities from "@/pages/Vulnerabilities";
import Exploits from "@/pages/Exploits";
import Reports from "@/pages/Reports";
import Pricing from "@/pages/Pricing";
import Admin from "@/pages/Admin";
import Schedules from "@/pages/Schedules";
import ToolHealth from "@/pages/ToolHealth";
import { Skull } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4 dark">
        <Skull className="h-10 w-10 text-primary animate-pulse" />
        <div className="font-mono text-sm text-muted-foreground">Vérification de la session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Google OAuth callback returns #session_id=... — handle before anything else
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/scanner" element={<Scanner />} />
        <Route path="/terminal" element={<LiveTerminal />} />
        <Route path="/vulnerabilities" element={<Vulnerabilities />} />
        <Route path="/exploits" element={<Exploits />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/schedules" element={<Schedules />} />
        <Route path="/tools" element={<ToolHealth />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
